import { Injectable } from '@angular/core';
import { GrpcLibService, GrpcLibServiceOption } from '../grpc-lib.service';
import { UserLibService } from '../../user/user-lib.service';
import { StorageLibService } from '../../storage/storage-lib.service';
import { Observable } from 'rxjs';
import * as grpcWeb from 'grpc-web';
import { PlaceConversionService } from '../../conversion/place/place-conversion.service';
import { GolfThemeConversionService } from '../../conversion/golf_class/golftheme-conversion.service';
import { Empty, GolfTheme } from 'src/app/libs/proto/commUnity_pb';

@Injectable({
  providedIn: 'root'
})
export class GrpcGolfThemeLibService {

  constructor(
    private grpcLib: GrpcLibService,
    private userLib: UserLibService,
    private storLib: StorageLibService,
    private convLib: GolfThemeConversionService,
  ) { }

  getGolfThemees(option?: GrpcLibServiceOption): Promise<GolfTheme[]>{
    return new Observable<GolfTheme[]>(obs => {
      const opt = this.grpcLib.getOption(option);
      opt.call.subscribe = obs;

      if (!this.grpcLib.Data.online || (opt.Offline || false)) {
        this._getGolfThemeesOffline(opt);
      } else {
        this._getGolfThemeesOnline(opt);
      }

    }).toPromise();
  }

  private _getGolfThemeesOffline(option: GrpcLibServiceOption){
    this.convLib.FromStorages(
      (this.storLib.get('g-thene-s') || this.storLib.get('g-theme')), (ns, e) => {
        if (e == null) {
          if ((option.call.req || '') !== ''){
            if (ns) {
              option.call.subscribe.next( ns.filter( n => {
                return n.getId() === option.call.req;
              }));
              option.call.subscribe.complete();
              return;
            }
          }
        }

        option.call.subscribe.next(ns || []);
        option.call.subscribe.complete();
    });
  }

  private _getGolfThemeesOnline(option: GrpcLibServiceOption){
    this.grpcLib.MobileClient.getGolfThemes(new Empty(), {
        token: this.userLib.Data.token?.getToken(),
      })
      .on('error', (e: grpcWeb.RpcError) => {
        this._getGolfThemeesOnlineError(e, option);
      })
      .on('status', (s: grpcWeb.Status) => {
        this._getGolfThemeesOnlineStatus(s, option);
      })
      .on('data', (r: GolfTheme) => {
        this._getGolfThemeesOnlineData(r, option);
      })
      .on('end', () => {
        this._getGolfThemeesOnlineEnd(option);
      });
  }

  private _getGolfThemeesOnlineData(ret: GolfTheme, option: GrpcLibServiceOption) {
    option.call.data.push(ret);
  }

  private _getGolfThemeesOnlineError(e: grpcWeb.RpcError, option: GrpcLibServiceOption) {
    const thise = this;

    this.grpcLib.handleError(e, () => {
      thise._getGolfThemeesOnline(option);
    }, option);
  }

  private _getGolfThemeesOnlineEnd(option: GrpcLibServiceOption) {
    option.call.subscribe.complete();
  }

  private _getGolfThemeesOnlineStatus(s: grpcWeb.Status, option: GrpcLibServiceOption) {
    if (s.code === 0) {
      this.storLib.cache.golfTheme = true;
      if (option.KeepInCache || false) {
        this.storLib.set(
          'g-theme', this.convLib.ToStorages(option.call.data)
        );
      }

      option.call.subscribe.next(option.call.data);
      if (option?.callback) { option?.callback(option.call.data); }
    } else {
      this.grpcLib.treatStatus(s, () => {
        this._getGolfThemeesOnline(option);
      }, option);
    }
  }
}
